module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak Nordic Walking czerwony.svg?e076d6b3";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak Nordic Walking czerwony.svg
// module id = 2012
// module chunks = 0